import { render } from "./serviceAgreement.vue?vue&type=template&id=589cabdd&scoped=true"
import script from "./serviceAgreement.vue?vue&type=script&lang=js"
export * from "./serviceAgreement.vue?vue&type=script&lang=js"

import "./serviceAgreement.vue?vue&type=style&index=0&id=589cabdd&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589cabdd"]])

export default __exports__